import { useCallback } from 'react';

export const useOrganisationToggle = ({
	companyMembers,
	fullData,
	setIsUserOrganisation,
	setData,
}) => {
	const toggleSwitch = useCallback(
		(val: boolean) => {
			setIsUserOrganisation((prev) => !prev);
			if (!val) {
				setData((data) =>
					data.filter((item) =>
						companyMembers?.some(
							(member) => member?.user?._id === item._id
						)
					)
				);
			} else {
				setData(fullData);
			}
		},
		[]
	);

	return { toggleSwitch };
};
